// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__1c25g","element":"App_element__3SvGx"};